import { connect } from 'react-redux'
import AgeGroupSelect from './age-groups-select'
import { fetchYearGroups } from '../../stores/year-groups/year-groups.actions'
import {
  getYearGroupsFetchingStatus,
  getYearGroups
} from '../../stores/year-groups/year-groups.selectors'

const mapStateToProps = state => {
  const fetchingStatus = getYearGroupsFetchingStatus(state)
  return {
    fetching: fetchingStatus.pending,
    fetchingError: !fetchingStatus.pending && fetchingStatus.requestError,
    ageGroups: getYearGroups(state)
  }
}

const mapDispatchToProps = dispatch => ({
  fetchAgeGroups: () => dispatch(fetchYearGroups()).catch(() => null)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AgeGroupSelect)
